import { Component, Input } from '@angular/core';
import { App } from 'ionic-angular';

@Component({
  selector: 'core-information',
  templateUrl: './information.component.html'
})
export class InformationComponent {

  constructor(
    public app: App
  ) {

  }


}



// WEBPACK FOOTER //
// ./src/core/information/information.component.ts